/**
 * A-04 承認範囲。自分が上長を務める承認グループと所属スタッフ。
 */

import { endpoints } from '../../api/endpoints.js';
import { Card, EmptyState, ErrorMessage, Loading, Notice } from '../../components/ui.js';
import { useAsync } from '../../lib/useAsync.js';

export function ApprovalScopePage(): React.JSX.Element {
  const state = useAsync(() => endpoints.approvalScope(), []);

  if (state.loading && !state.data) return <Loading />;
  if (state.error) return <ErrorMessage error={state.error} />;
  if (!state.data) return <Loading />;

  const { group, approver, members, note } = state.data;

  return (
    <>
      <Notice tone="info" title="所属部門と承認グループは別の設定です">
        {note}
      </Notice>

      <Card title={group?.name ?? '承認グループ未設定'} description={group?.description}>
        <p className="text-sm">
          上長：<span className="font-semibold">{approver.name}</span>（{approver.department}）
        </p>
      </Card>

      <Card title={`所属スタッフ ${members.length}名`}>
        {members.length === 0 ? (
          <EmptyState message="このグループに所属するスタッフはいません。" />
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>社員ID</th>
                <th>氏名</th>
                <th>所属部門</th>
                <th>入社日</th>
                <th>在籍</th>
              </tr>
            </thead>
            <tbody>
              {members.map((member) => (
                <tr key={member.id}>
                  <td>{member.employeeId}</td>
                  <td className="font-semibold">{member.name}</td>
                  <td className="text-ink-muted">{member.department}</td>
                  <td>{member.hireDate ?? '—'}</td>
                  <td>
                    <span className={`pill ${member.active ? 'pill--ok' : 'pill--muted'}`}>
                      {member.active ? '在籍' : '無効'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </>
  );
}
